import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GreenCornerService } from '../../../../../services/green-corner-service/green-corner.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-green-corner-tag',
  templateUrl: './green-corner-tag.component.html',
  styleUrls: ['./green-corner-tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GreenCornerTagComponent implements OnInit {
  @Input() isGreenCorner = false;

  greenCornerPrice$: Observable<number>;
  loading$: Observable<boolean>;

  constructor(private greenCornerService: GreenCornerService) {}

  ngOnInit(): void {
    const ref = this.greenCornerService.fetchGreenCornerPrice();
    this.loading$ = ref.loading$;
    this.greenCornerPrice$ = ref.data$.pipe(map((data) => data?.price ?? 0));
  }
}
